/* eslint-disable react/no-danger */
import React from 'react';
import classNames from 'classnames';

function renderAmp() {
  const {
    alt,
    height: originalHeight,
    width: originalWidth,
    caption,
    credits,
    displayImageMetadata,
    ampLayout,
    ampFixedMaxWidth,
    ampDensity,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  } = this.props;

  const {
    src,
    srcSet,
    width: transformedWidth,
    height: transformedHeight,
  } = this.sizes;

  let ampFixedWidth = originalWidth;
  let ampFixedHeight = originalHeight;

  if (ampLayout === 'fixed') {
    if (originalWidth > ampFixedMaxWidth) {
      ampFixedWidth = ampFixedMaxWidth;
      ampFixedHeight = (ampFixedWidth / originalWidth) * originalHeight;

      // only set half the image is the image is wider than the max width
      if (ampDensity) {
        ampFixedWidth /= 2;
        ampFixedHeight /= 2;
      }
    }
  }

  const srcset = (srcSet && srcSet.length) ? srcSet : undefined;

  let width = transformedWidth === 0 ? (originalWidth * transformedHeight) / originalHeight : transformedWidth;
  let height = transformedHeight === 0 ? (transformedWidth * originalHeight) / originalWidth : transformedHeight;

  width = (ampLayout === 'fixed' && ampFixedWidth) ? ampFixedWidth : (width || 0);
  height = (ampLayout === 'fixed' && ampFixedHeight) ? ampFixedHeight : (height || 0);

  const imageTag = (
    <amp-img
      src={src}
      srcset={width && height ? srcset : undefined}
      width={width}
      height={height}
      alt={alt || ''}
      role="presentation"
      layout={ampLayout}
    >
      <noscript>
        <img
          src={src}
          width={width}
          height={height}
          alt={alt || ''}
        />
      </noscript>
    </amp-img>
  );

  if ((caption || credits) && displayImageMetadata) {
    return (
      <div
        className={classNames({
          [`${cssPrefix}__image--wrapper`]: loadStyles,
          ...extraClassNames,
        })}
      >
        <figure className={`${cssPrefix}__image--image`}>
          {imageTag}
        </figure>

        <div className={`${cssPrefix}__image--meta`}>
          {caption && <p className={`${cssPrefix}__image--caption`}>{caption}</p>}
          {credits && <p className={`${cssPrefix}__image--credits`} dangerouslySetInnerHTML={{ __html: credits }} />}
        </div>
      </div>
    );
  }

  return imageTag;
}

export default renderAmp;
